import { Select, Button, Input, Card, Tooltip } from "antd";

import styles from "./index.module.less";
import DisplayMaster from "./DisplayMaster";
import { ModuleAndIdMapping, Modules, Operations } from "../../constants/DatabaseConstants/MasterConstant";
import { General } from "../../util/General";
import Authentication from "../../util/Authentication";

import useMasterManagement from "./index.hook";
import AccessControlMaster from "./ModalComponents/AccessControlMaster";
import { UserRoleDATA } from "../../constants/DatabaseConstants/AuthConstants";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import CircularProgressBar from "../common/CircularProgressBar";
import Loading from "../common/Loading";

const ModuleOptions = [
  { module: Modules.CONFIG_MASTER, label: "Config Master", value: ModuleAndIdMapping[Modules.CONFIG_MASTER] },
  { module: Modules.ROLE_MASTER, label: "Role Master", value: ModuleAndIdMapping[Modules.ROLE_MASTER] },
  { module: Modules.LOCATION_TYPE_MASTER, label: "Location Type Master", value: ModuleAndIdMapping[Modules.LOCATION_TYPE_MASTER] },
  { module: Modules.PARKING_MAP_TYPE_MASTER, label: "Parking Map Type Master", value: ModuleAndIdMapping[Modules.PARKING_MAP_TYPE_MASTER] },
  { module: Modules.CUSTOMER_MASTER, label: "Customer Master", value: ModuleAndIdMapping[Modules.CUSTOMER_MASTER] },
  { module: Modules.CUSTOMER_LOCATION_MASTER, label: "Customer Location Master", value: ModuleAndIdMapping[Modules.CUSTOMER_LOCATION_MASTER] },
  { module: Modules.CUSTOMER_CLIENT_MASTER, label: "Customer Client Master", value: ModuleAndIdMapping[Modules.CUSTOMER_CLIENT_MASTER] },
  { module: Modules.KEY_FOB_MASTER, label: "KeyFob Master", value: ModuleAndIdMapping[Modules.KEY_FOB_MASTER] },
  { module: Modules.KEY_FOB_ALLOCATION_MASTER, label: "KeyFob Allocation Master", value: ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER] },
  { module: Modules.PRICING_MASTER, label: "Pricing Master", value: ModuleAndIdMapping[Modules.PRICING_MASTER] },
  { module: Modules.ADVANCE_BOOKING_QUOTA_MASTER, label: "Advance Booking Quota Master", value: ModuleAndIdMapping[Modules.ADVANCE_BOOKING_QUOTA_MASTER] },
  { module: Modules.NOTIFICATION_MASTER, label: "Notification Master", value: ModuleAndIdMapping[Modules.NOTIFICATION_MASTER] },
  { module: Modules.FAQ_MASTER, label: "FAQ Master", value: ModuleAndIdMapping[Modules.FAQ_MASTER] }
];

const MasterManagement = () => {
  const config = useMasterManagement();

  const showAddBtn = config.selectedId && Authentication.checkModuleAccessById(config.userData, config.selectedId, Operations.CREATE);

  return (
    <div>
      <Card className="gx-card card--height" title={null}>
        {config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_MASTER] && (
          <div className={styles["stats-container"]}>
            <span>
              TOTAL PARKING SLOTS : <b>{config?.totalParkingSlots ?? 0}</b>
            </span>
            <span>
              KEYFOB COUNT : <b>{config?.keyFobsCount ?? 0}</b>
            </span>
          </div>
        )}

        {/* header filters */}
        <div className={styles["master-container"]}>
          <div className={styles["section1"]}>
            <span className="card-title-style">Master Management</span>

            <Select getPopupContainer={(trigger) => trigger.parentElement} className={`${styles["select-master-dropdown"]}`} placeholder="Select Master Name" onChange={config.handleListSelect} value={config.selectedId} showSearch filterOption={General.searchFilterOnSelect}>
              {ModuleOptions.map(
                (option) =>
                  Authentication.hasModuleAndOperationAccess(config.userData, option.module, Operations.READ) && (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  )
              )}
              {config?.userData?.role === UserRoleDATA.PARI_ADMIN && (
                <Select.Option key={ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER]} value={ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER]}>
                  {"Web Access Control Master"}
                </Select.Option>
              )}
            </Select>
          </div>

          <div className={styles["section2"]}>
            {config.selectedId !== ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER] && <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} onSearch={config.handleChangeOnSearch} onChange={(e) => config.handleChangeSearch(e.target.value)} value={config.searchedText} />}

            {showAddBtn && (
              <div>
                <Button disabled={config.isAddButtonDisabled()} className={`button-gradiant gx-mb-0 add-button`} onClick={config.handleAddClick}>
                  Add
                </Button>

                {/* commented for now, might be required later */}
                {/* {config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_MASTER] && (
                  <Button className={`button-gradiant gx-mb-0 add-button`} onClick={config.handleBulkEditRecord.bind(this, true)}>
                    Edit
                  </Button>
                )} */}

                {/* Export File Icons */}
                {/* {(config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_MASTER] || config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER]) && (
                  <Tooltip title="Download Excel File">
                    <Button type="link" className={`gx-mb-0`} icon={config?.excelIconLoading ? <CircularProgressBar /> : <FileExcelOutlined className={styles["excel-icon"]} />} onClick={config.handleExportExcelFile} />
                  </Tooltip>
                )} */}
                {(config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_MASTER] || config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER]) && (
                  <Tooltip title="Download PDF File">
                    <Button type="link" className={`gx-mb-0`} icon={config?.pdfIconLoading ? <CircularProgressBar /> : <FilePdfOutlined className={styles["pdf-icon"]} />} onClick={config.handleExportPDFFile} />
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>

        {!config.dropdownDataLoading ? (
          <>
            {config.selectedId === ModuleAndIdMapping[Modules.KEY_FOB_ALLOCATION_MASTER] && (
              <div className={styles["master-filters"]}>
                <div className={styles["dropdown-filter-label"]}>
                  <span>Client</span>
                </div>
                <Select className={`${styles["filter-master-dropdown"]}`} disabled={!config?.masterFilters?.locationId} value={config?.masterFilters?.clientId ?? null} onChange={config.handleChangeClient} listHeight={200} showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select client">
                  {config.clientList?.map((item: { id: number; client_name: string }) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.client_name}
                    </Select.Option>
                  ))}
                </Select>

                <div className={styles["dropdown-filter-label"]}>
                  <span>KeyFob Token</span>
                </div>
                <Select className={`${styles["filter-master-dropdown"]}`} disabled={!config?.masterFilters?.locationId} value={config?.masterFilters?.keyFobId ?? null} onChange={config.handleChangeKeyFob} showSearch listHeight={200} allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select KeyFob token">
                  {config.keyFobList?.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item?.key_fob_token}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            )}

            {/* Display Table component */}
            {config.selectedId && (
              <div className={styles["master-data-table"]}>
                {config.selectedId === ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER] && <AccessControlMaster />}
                {config.selectedId !== ModuleAndIdMapping[Modules.WEB_FE_ACCESS_CONTROL_MASTER] && <DisplayMaster addBtnDisplay={config.addView} addRecord={config.addRecord} searchedText={config.searchedText} handleSearchedText={config.handleSearchedText} handleAddBtnDisplay={config.handleAddView} handleAddRecord={config.handleAddRecord} handleBulkEditRecord={config.handleBulkEditRecord} bulkEditRecord={config.bulkEditRecord} />}
              </div>
            )}
          </>
        ) : (
          <Loading />
        )}
      </Card>
    </div>
  );
};
export default MasterManagement;
